export const constants = {
  // `VITE_HOST_URL` est consommé directement dans index.html
  // (`<link rel="canonical" href="%VITE_HOST_URL%" />`) — pas d'exposition JS.
  passengerApi: import.meta.env.VITE_PASSENGER_API || '',
  extranetApi: import.meta.env.VITE_EXTRANET_API || '',
  basename: import.meta.env.VITE_BASENAME || '',
  mode: import.meta.env.MODE || '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
  isProduction: import.meta.env.VITE_API_ENV === 'production',
  isLocal: import.meta.env.MODE === 'local-extranet' || import.meta.env.MODE === 'development',
  version: import.meta.env.VITE_APP_VERSION || '',
  sentryRelease: import.meta.env.VITE_SENTRY_RELEASE || '',
  storagePrefix: import.meta.env.VITE_STORAGE_PREFIX || 'extranet',
  commitAuthor: import.meta.env.VITE_COMMIT_AUTHOR || '',
  commitMessage: import.meta.env.VITE_COMMIT_MESSAGE || '',
  commitHash: import.meta.env.VITE_COMMIT_HASH || '',
};
